import { ReactComponent as MyProfileIcon } from "../icons/ProfileMenuIcons/MyProfileIcon.svg";
import { ReactComponent as ManageIcon } from "../icons/ProfileMenuIcons/ManageIcon.svg";
import { ReactComponent as FollowingIcon } from "../icons/ProfileMenuIcons/FollowingIcon.svg";
import { ReactComponent as SavedContentIcon } from "../icons/ProfileMenuIcons/SavedContentIcon.svg";
import { ReactComponent as MyNichesIcon } from "../icons/ProfileMenuIcons/MyNichesIcon.svg";
import { ReactComponent as SettingsIcon } from "../icons/ProfileMenuIcons/SettingsIcon.svg";
import { ReactComponent as LogoutIcon } from "../icons/ProfileMenuIcons/LogoutIcon.svg";

const ProfileMenuIcons = {
  MyProfileIcon,
  ManageIcon,
  FollowingIcon,
  SavedContentIcon,
  MyNichesIcon,
  SettingsIcon,
  LogoutIcon,
};

export default ProfileMenuIcons;
